/// ---------------------首页粘性大图模块---------------
//  点击加载更多功能（在模块上选择最大数量，在后台模块添加了css控制让手机端显示默认6个 电脑显示4个）
document.addEventListener("DOMContentLoaded", function () {
  const products = document.querySelectorAll('.collection-split__products .float-grid .collection-split__product');
  const btn = document.querySelector('.newmorebtn');
  let itemsToShow = 6;
  const increment = 4;

  if (products.length && btn) {
    function showMoreProducts() {
      itemsToShow += increment;
      products.forEach((product, index) => {
        if (index < itemsToShow) product.style.display = "block";
      });
      if (itemsToShow >= products.length) btn.style.display = "none";
    }
    if (window.innerWidth <= 768) {
      btn.addEventListener("click", showMoreProducts);
    }
  }
});

// ------------------------首页新闻模块让电脑端右边盒子合意左右滑动--------------------
document.addEventListener("DOMContentLoaded", function () {
  const slider = document.querySelector("#new-home-news .NewRight");
  if (!slider) return;

  let isDown = false, startX, scrollLeft;

  slider.addEventListener("mousedown", (e) => {
    isDown = true;
    slider.classList.add("active");
    startX = e.pageX - slider.offsetLeft;
    scrollLeft = slider.scrollLeft;
  });

  slider.addEventListener("mouseleave", () => isDown = false);
  slider.addEventListener("mouseup", () => isDown = false);
  slider.addEventListener("mousemove", (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - slider.offsetLeft;
    const walk = (x - startX) * 2;
    slider.scrollLeft = scrollLeft - walk;
  });
});

// ------------------详情页分期价更新 --------------------
function updateInstallment() {
  const priceEl = document.querySelector('[data-product-price]');
  const installmentEl = document.querySelector('[data-installment-price]');
  if (priceEl && installmentEl) {
    const price = parseFloat(priceEl.innerText.replace(/[^0-9.]/g, ''));
    if (!isNaN(price)) installmentEl.innerText = `$${(price / 4).toFixed(2)}`;
  }
}
document.addEventListener("DOMContentLoaded", updateInstallment);
const target = document.querySelector('[data-product-price]');
if (target) new MutationObserver(updateInstallment).observe(target, { childList: true, characterData: true, subtree: true });

// ---------------------分期价弹窗 ----------------------------
document.addEventListener("DOMContentLoaded", function () {
  const popupBox = document.querySelector(".newPopUpBox");
  const popupOne = document.querySelector(".newPopUpOne");
  const popupTwo = document.querySelector(".newPopUpTwo");
  const afterPop = document.querySelector(".newAfterPop");
  const klamaPop = document.querySelector(".newklamaPop");
  const afterImg = document.querySelector(".newAfterImg");
  const klaImg = document.querySelector(".newKlaImg");
  const closeBtnOne = document.querySelector(".newCloseBtnOne");
  const closeBtnTwo = document.querySelector(".newCloseBtnTWO");

  if (afterImg) afterImg.addEventListener("click", (e) => { e.stopPropagation(); showPopup("one"); });
  if (klaImg) klaImg.addEventListener("click", (e) => { e.stopPropagation(); showPopup("two"); });
  if (closeBtnOne) closeBtnOne.addEventListener("click", (e) => { e.stopPropagation(); hidePopup(); });
  if (closeBtnTwo) closeBtnTwo.addEventListener("click", (e) => { e.stopPropagation(); hidePopup(); });

  if (popupBox) {
    popupBox.addEventListener("click", hidePopup);
    [popupOne, popupTwo].forEach(popup => popup?.addEventListener("click", e => e.stopPropagation()));
  }

  function showPopup(type) {
    popupBox.style.display = "block";
    popupOne.style.display = type === "one" ? "block" : "none";
    popupTwo.style.display = type === "two" ? "block" : "none";
    afterPop.style.display = type === "one" ? "block" : "none";
    klamaPop.style.display = type === "two" ? "block" : "none";
  }

  function hidePopup() {
    popupBox.style.display = "none";
    popupOne.style.display = "none";
    popupTwo.style.display = "none";
  }
});

// --------------------------优惠券弹窗 + 复制 --------------------------
document.addEventListener('DOMContentLoaded', function () {
  const discountBtn = document.querySelector('.DiscountsBtn');
  const discountOverlay = document.querySelector('.NewDiscountszhezhao');
  const discountBox = document.querySelector('.NewDiscountsBox');
  const discountCloseIcon = document.querySelector('.DiscountsIcon');

  if (discountBtn && discountOverlay && discountBox && discountCloseIcon) {
    discountBtn.addEventListener('click', () => {
      discountOverlay.style.display = 'block';
      discountBox.style.display = 'block';
    });
    discountCloseIcon.addEventListener('click', () => {
      discountOverlay.style.display = 'none';
      discountBox.style.display = 'none';
    });
    discountOverlay.addEventListener('click', e => {
      if (e.target === discountOverlay) {
        discountOverlay.style.display = 'none';
        discountBox.style.display = 'none';
      }
    });
  }

  document.querySelectorAll('.DiscountsCopy').forEach(button => {
    button.addEventListener('click', function () {
      const codeText = this.closest('.Discounts_bot_text')?.querySelector('.DiscountsCode_text')?.innerText;
      if (!codeText) return;
      navigator.clipboard.writeText(codeText).then(() => {
        const originalText = this.innerText;
        this.innerText = 'copied';
        setTimeout(() => this.innerText = originalText, 500);
      }).catch(err => console.error('复制失败:', err));
    });
  });
});

// ------------------------详情页折叠项弹窗 ----------------------------
document.addEventListener("DOMContentLoaded", function () {
  const jumpBox = document.querySelector('.newJumpBox');
  const jumpItems = document.querySelectorAll('.newJumpItem');
  const jumps = document.querySelectorAll('.newJump');
  const closeBtns = document.querySelectorAll('.jumpBtn');

  if (!jumpBox || !jumpItems.length || !jumps.length) return;

  const observer = new MutationObserver(() => {
    let activeIndex = -1;
    jumpItems.forEach((item, index) => {
      if (item.classList.contains('accordion-is-open')) activeIndex = index;
    });
    if (activeIndex !== -1) {
      jumpBox.style.display = 'block';
      jumps.forEach(j => j.style.display = 'none');
      if (jumps[activeIndex]) jumps[activeIndex].style.display = 'block';
    }
  });
  jumpItems.forEach(item => observer.observe(item, { attributes: true, attributeFilter: ['class'] }));

  closeBtns.forEach(btn => btn.addEventListener('click', closeJump));
  jumpBox.addEventListener('click', closeJump);
  jumps.forEach(jump => jump.addEventListener('click', e => e.stopPropagation()));

  function closeJump() {
    jumpBox.style.display = 'none';
    jumps.forEach(j => j.style.display = 'none');
    jumpItems.forEach(item => item.classList.remove('accordion-is-open'));
  }
});

// ---------------------详情页规格size弹窗 ------------------
document.addEventListener("DOMContentLoaded", function () {
  const openBtn = document.querySelector(".newtanhcuangBtn");
  const modalBox = document.querySelector(".newSizeBox");
  const modalContent = document.querySelector(".newSizeOne");
  const closeBtn = document.querySelector(".newSizeBtnTWO");

  if (openBtn && modalBox && modalContent && closeBtn) {
    openBtn.addEventListener("click", () => {
      modalBox.style.display = "block";
      modalContent.style.display = "block";
    });
    closeBtn.addEventListener("click", (e) => {
      e.stopPropagation();
      modalBox.style.display = "none";
      modalContent.style.display = "none";
    });
    modalBox.addEventListener("click", () => {
      modalBox.style.display = "none";
      modalContent.style.display = "none";
    });
    modalContent.addEventListener("click", (e) => e.stopPropagation());
  }
});

// ------------------详情页color弹窗 --------------------------
document.addEventListener("DOMContentLoaded", function () {
  const openBtn = document.querySelector('.newColorBtn');
  const modal = document.querySelector('.newColorbox');
  const closeBtn = document.querySelector('.colorClose');

  if (openBtn && modal && closeBtn) {
    openBtn.addEventListener('click', () => modal.style.display = 'block');
    closeBtn.addEventListener('click', () => modal.style.display = 'none');
    modal.addEventListener('click', (e) => {
      if (e.target === modal) modal.style.display = 'none';
    });
  }
});

// -------------------------------------↑----------------------------------------


// ----------------------及时雨-------------------------
let jsy_plugin_api = null;

window.addEventListener('jsy_plugin_ready', evt => {
  jsy_plugin_api = evt.detail;

  // 初始化设置
  jsy_plugin_api.setOptions({
    closeButtonVisible: true,
    launcherButtonVisible: false,
    // email: 'enter your email',
  });

  // 绑定点击事件到你自定义的图标按钮
  const jsyBtn = document.querySelector('.jishiyu_icon');
  if (jsyBtn) {
    jsyBtn.addEventListener('click', () => {
      jsy_plugin_api.open({
        view: 'RegisterView'
      });
    });
  }
});
// -------------------------------------↑----------------------------------------


// --------------------固定header（不上线了）----------------------
// document.addEventListener("DOMContentLoaded", function () {
//     const announcement = document.getElementById("shopify-section-sections--15217513889838__announcement");
//     const header = document.getElementById("shopify-section-sections--15485308108846__header");

//     // 记录初始高度
//     const announcementHeight = announcement.offsetHeight;
//     const stickyTrigger = announcement.offsetTop; // 滚动过这个位置就触发固定

//     // 创建占位元素防止页面跳动
//     const announcementPlaceholder = document.createElement("div");
//     const headerPlaceholder = document.createElement("div");
//     announcementPlaceholder.style.height = announcementHeight + "px";
//     headerPlaceholder.style.height = header.offsetHeight + "px";

//     let isFixed = false;

//     function updateSticky() { 
//       const scrollY = window.scrollY;

//       if (scrollY >= stickyTrigger && !isFixed) {
//         // 插入占位元素
//         announcement.parentNode.insertBefore(announcementPlaceholder, announcement);
//         header.parentNode.insertBefore(headerPlaceholder, header);

//         // 固定两个盒子
//         announcement.style.position = "fixed";
//         announcement.style.top = "0";
//         announcement.style.left = "0";
//         announcement.style.right = "0";
//         announcement.style.zIndex = "1000";

//         header.style.position = "fixed";
//         header.style.top = announcementHeight + "px";
//         header.style.left = "0";
//         header.style.right = "0";
//         header.style.zIndex = "999";

//         isFixed = true;
//       } else if (scrollY < stickyTrigger && isFixed) {
//         // 取消 fixed，还原
//         announcement.style.position = "";
//         announcement.style.top = "";
//         announcement.style.left = "";
//         announcement.style.right = "";
//         announcement.style.zIndex = "";

//         header.style.position = "";
//         header.style.top = "";
//         header.style.left = "";
//         header.style.right = "";
//         header.style.zIndex = "";

//         // 移除占位元素
//         if (announcementPlaceholder.parentNode) {
//           announcementPlaceholder.remove();
//         }
//         if (headerPlaceholder.parentNode) {
//           headerPlaceholder.remove();
//         }

//         isFixed = false;
//       }
//     }

//     window.addEventListener("scroll", updateSticky);
//   });
// -----------------------------------↑---------------------------------------





// -----------------------点击首页价格盒子时候，触发新增加购按钮--------------------

document.addEventListener('DOMContentLoaded', function () {
  // 使用 matchMedia 判断屏幕宽度是否小于等于 768px（常见手机分辨率）
  if (!window.matchMedia('(max-width: 768px)').matches) return;

  document.addEventListener('click', function (e) {
    const priceBox = e.target.closest('.product__grid__price');
    if (!priceBox) return;

    // 防止点击价格区域中的 <a> 时发生跳转
    e.preventDefault();

    // 找到当前商品块容器
    const productContainer = priceBox.closest('.product__grid__info');
    if (!productContainer) return;

    // 查找加购按钮
    const addToCartBtn = productContainer.querySelector('.NewAddBtnPosition .newAddBtn');

    if (addToCartBtn) {
      addToCartBtn.click();
    }
  });
});

// ----------------------------------↑--------------------------------------- 

// --------------------------加购弹窗：不让自动关闭+图片区域可以拖拽-----------------------------
(function QuickViewModalManager() {
  const modalSelector = '.quickview__modal';
  const imagesSelector = '.quickview__modal__images';

  window.preventQuickViewClose = true;

  let dragHandlers = null;

  function removeDragHandlers(container) {
    if (!dragHandlers || !container) return;
    container.removeEventListener('mousedown', dragHandlers.mousedown);
    container.removeEventListener('mouseup', dragHandlers.mouseup);
    container.removeEventListener('mouseleave', dragHandlers.mouseleave);
    container.removeEventListener('mousemove', dragHandlers.mousemove);
    dragHandlers = null;
  }

  function enableDragScroll(container) {
    removeDragHandlers(container);

    let isDragging = false;
    let startX = 0;
    let scrollLeft = 0;

    container.style.cursor = 'grab';

    function onMouseDown(e) {
      isDragging = true;
      container.style.cursor = 'grabbing';
      startX = e.pageX - container.getBoundingClientRect().left;
      scrollLeft = container.scrollLeft;
      e.preventDefault();
    }

    function onMouseUp() {
      isDragging = false;
      container.style.cursor = 'grab';
    }

    function onMouseLeave() {
      isDragging = false;
      container.style.cursor = 'grab';
    }

    function onMouseMove(e) {
      if (!isDragging) return;
      e.preventDefault();
      const x = e.pageX - container.getBoundingClientRect().left;
      const walk = (x - startX) * 2;
      container.scrollLeft = scrollLeft - walk;
    }

    container.addEventListener('mousedown', onMouseDown);
    container.addEventListener('mouseup', onMouseUp);
    container.addEventListener('mouseleave', onMouseLeave);
    container.addEventListener('mousemove', onMouseMove);

    dragHandlers = {
      mousedown: onMouseDown,
      mouseup: onMouseUp,
      mouseleave: onMouseLeave,
      mousemove: onMouseMove,
    };
  }

  function attachCloseListener(modal) {
    if (modal._closeListenerAttached) return;
    modal._closeListenerAttached = true;

    document.addEventListener('click', (e) => {
      const closeBtn = e.target.closest('.drawer__close');
      const underlay = e.target.closest('.drawer__underlay');

      // 如果点击了关闭按钮或遮罩，允许关闭
      if ((closeBtn || underlay) && modal.classList.contains('is-open')) {
        window.preventQuickViewClose = false;

        if (window.MicroModal?.close) {
          window.MicroModal.close(modal.id || undefined);
        } else {
          modal.setAttribute('aria-hidden', 'true');
          modal.classList.remove('is-open');
        }
      }
    });
  }


  function attachMutationObserver(modal) {
    if (modal._mutationObserverAttached) return;
    modal._mutationObserverAttached = true;

    const observer = new MutationObserver((mutations) => {
      let shouldPreventClose = false;

      mutations.forEach((mutation) => {
        if (
          mutation.type === 'attributes' &&
          ['aria-hidden', 'class'].includes(mutation.attributeName)
        ) {
          const isHidden = modal.getAttribute('aria-hidden') === 'true';
          const isOpen = modal.classList.contains('is-open');

          if (window.preventQuickViewClose && isHidden && !isOpen) {
            // 检查是否有内容，避免空盒子重新打开
            const container = modal.querySelector(imagesSelector);
            const hasContent = container && container.children.length > 0;
            if (hasContent) {
              shouldPreventClose = true;
            }
          }
        }
      });

      if (shouldPreventClose) {
        console.log('🛑 阻止自动关闭，恢复弹窗显示');
        modal.setAttribute('aria-hidden', 'false');
        modal.classList.add('is-open');
      }
    });

    observer.observe(modal, {
      attributes: true,
      attributeFilter: ['aria-hidden', 'class'],
    });
  }

  function attachReopenObserver(modal) {
    if (modal._reopenObserverAttached) return;
    modal._reopenObserverAttached = true;

    const observer = new MutationObserver(() => {
      const isOpen = modal.classList.contains('is-open');
      const isHidden = modal.getAttribute('aria-hidden') === 'false';

      if (isOpen && isHidden) {
        console.log('🔁 弹窗重新打开，恢复阻止关闭和绑定拖拽');
        window.preventQuickViewClose = true;

        const container = modal.querySelector(imagesSelector);
        if (container) enableDragScroll(container);
      }
    });

    observer.observe(modal, {
      attributes: true,
      attributeFilter: ['class', 'aria-hidden'],
    });
  }

  function observeModal() {
    const modal = document.querySelector(modalSelector);
    if (!modal) return false;

    attachCloseListener(modal);
    attachMutationObserver(modal);
    attachReopenObserver(modal);

    if (modal.classList.contains('is-open')) {
      window.preventQuickViewClose = true;
      const container = modal.querySelector(imagesSelector);
      if (container) enableDragScroll(container);
    }

    const classObserver = new MutationObserver(() => {
      if (modal.classList.contains('is-open')) {
        window.preventQuickViewClose = true;
        const container = modal.querySelector(imagesSelector);
        if (container) enableDragScroll(container);
      }
    });

    classObserver.observe(modal, {
      attributes: true,
      attributeFilter: ['class'],
    });

    return true;
  }

  const bodyObserver = new MutationObserver((_, obs) => {
    if (observeModal()) {
      obs.disconnect();
    }
  });

  bodyObserver.observe(document.body, {
    childList: true,
    subtree: true,
  });
})();
// ----------------------------------↑--------------------------------------- 


// ----------------------加购弹窗选择规格时候滑动图片--------------------
document.body.addEventListener('click', e => {
  const label = e.target.closest('label[data-media-id]');
  if (!label) return;

  const mediaId = label.dataset.mediaId;
  if (!mediaId) return;

  // ===== 手动选中 input，确保样式同步 =====
  const inputId = label.getAttribute('for');
  const input = document.getElementById(inputId);

  if (input) {
    input.checked = true;
    input.dispatchEvent(new Event('change', { bubbles: true }));
    e.preventDefault(); // 只在有 input 时拦截默认事件
  }

  // ===== 图片切换逻辑 =====
  const imagesWrapper = document.querySelector('.quickview__modal__images');
  if (!imagesWrapper) return;

  document.querySelectorAll('label[data-media-id].is-selected').forEach(l => l.classList.remove('is-selected'));
  imagesWrapper.querySelectorAll('.product__media.is-selected').forEach(m => m.classList.remove('is-selected'));

  label.classList.add('is-selected');
  const targetImage = imagesWrapper.querySelector(`.product__media[data-media-id="${mediaId}"]`);
  if (targetImage) {
    targetImage.classList.add('is-selected');
    targetImage.scrollIntoView({ behavior: 'smooth', inline: 'center' });
  }
});
// ----------------------------------↑--------------------------------------- 


// =-----------------------------热搜滑动----------------------
document.addEventListener('DOMContentLoaded', function () {
  // 避免重复绑定
  if (window.__hotSearchScrollBound) return;
  window.__hotSearchScrollBound = true;

  const wrappers = document.querySelectorAll('.scroll-wrapper');
  const realWrapper = Array.from(wrappers).find(w => w.scrollWidth > w.clientWidth);

  if (!realWrapper) {
    console.warn('没有找到有效的 scroll-wrapper');
    return;
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest('.newleft')) {
      realWrapper.scrollBy({ left: -200, behavior: 'smooth' });
    } else if (e.target.closest('.newright')) {
      realWrapper.scrollBy({ left: 200, behavior: 'smooth' });
    }
  });
});
// ----------------------------------↑--------------------------------------- 

//-------------------加购弹窗购买按钮 文案变化-----------------------
(function () {
  const selector = ".drawer__content .product__form__outer .shopify-payment-button__more-options";

  function replaceMoreOptionsText() {
    const el = document.querySelector(selector);
    if (el && el.textContent.includes("More payment options")) {
      el.textContent = "CHECK OUT";
    }
  }

  // 启动 observer，永远监听 DOM 插入
  const observer = new MutationObserver(() => {
    replaceMoreOptionsText();
  });

  observer.observe(document.body, {
    childList: true,
    subtree: true
  });

  // 页面初次渲染尝试替换一次
  replaceMoreOptionsText();
})();
// ----------------------------------↑--------------------------------------- 


// ----------------------库存数量显示（动态切换）--------------------
document.addEventListener("DOMContentLoaded", function () {
  const stockEl = document.querySelector('[data-product-remaining-json]');
  if (!stockEl) return;

  let stockData;
  try {
    stockData = JSON.parse(stockEl.textContent.trim());
  } catch {
    stockData = {};
  }

  const stockDisplay = document.getElementById("NewVariant-stock-display");
  if (!stockDisplay) return;


  function updateStockDisplay(variantId) {
    const stockRaw = stockData[variantId];
    const stock = parseInt(stockRaw, 10);
    const progressBar = document.querySelector(".newInventory-progress");
    const stockText = document.getElementById("NewVariant-stock-display");

    // 清除旧的 class，切换新的类名
    progressBar?.classList.remove("low", "critical", "newstockout");
    stockText?.classList.remove("low", "critical", "newstockout");

    if (stockRaw === null || stockRaw === undefined || isNaN(stock) || stock <= 0) {
      stockText.textContent = "0";
      progressBar?.classList.add("newstockout");
      stockText?.classList.add("newstockout");
    } else if (stock <= 10) {
      stockText.textContent = `Just ${stock} Left in Stock!`;
      progressBar?.classList.add("critical");
      stockText?.classList.add("critical");
    } else if (stock <= 50) {
      stockText.textContent = `Only ${stock} Left - Selling Fast!`;
      progressBar?.classList.add("low");
      stockText?.classList.add("low");
    } else {
      stockText.textContent = `${stock} in stock, ready to ship`;
    }
  }


  const variantInput = document.querySelector('input[name="id"]');
  if (variantInput) {
    updateStockDisplay(variantInput.value);

    // 监听变体ID变化（下拉或按钮切换）
    variantInput.addEventListener("change", function () {
      updateStockDisplay(this.value);
    });
  }

  // 监听主题触发的自定义事件 variant:change
  document.addEventListener('variant:change', function (e) {
    const variantId = e?.detail?.variant?.id;
    if (variantId) updateStockDisplay(variantId);
  });
});
// ----------------------------------↑--------------------------------------- 



// 加购后直接进入购物车
// document.addEventListener('DOMContentLoaded', function () {
//   const addToCartBtn = document.querySelector('[data-add-to-cart]');

//   if (addToCartBtn) {
//     addToCartBtn.addEventListener('click', function () {
//       setTimeout(function () {
//         window.location.href = '/cart';
//       }, 800);
//     });
//   }
// });
// -------------------↑----------------------





// -------------------------降价模块加载更多功能--------------------
document.addEventListener("DOMContentLoaded", function () {
  const sections = document.querySelectorAll(".newReduction");

  sections.forEach(section => {
    const enableLoadMore = section.dataset.loadMore === "true";

    const products = section.querySelectorAll(".flash-sale-product");
    const btn = section.querySelector(".ReductionBtn");

    // ❗ 如果关闭加载更多：直接全部显示 + 隐藏按钮
    if (!enableLoadMore) {
      products.forEach(item => item.style.display = "block");
      if (btn) btn.style.display = "none";
      return;
    }

    const initialCount = 16;
    const loadMoreCount = 4;
    let visibleCount = initialCount;

    function updateVisibility() {
      products.forEach((item, index) => {
        item.style.display = index < visibleCount ? "block" : "none";
      });

      if (visibleCount >= products.length) {
        btn.style.display = "none";
      }
    }

    updateVisibility();

    btn?.addEventListener("click", function () {
      visibleCount += loadMoreCount;
      updateVisibility();
    });
  });
});
// -------------------↑----------------------


// ------------------库存条动态变化---------------------
document.addEventListener("DOMContentLoaded", () => {
  // 定义两个库存组件的配置（方便扩展）
  const stockConfigs = [
    {
      containerSelector: ".newStockBox",
      barSelector: ".new_stock",
      textSelector: ".newStocktext",
      textFormat: (v) => `${v}% sold`,
      storagePrefix: "newStockProgress_",
    },
    {
      containerSelector: ".newChangeStockBox",
      barSelector: ".new_Changestock",
      textSelector: ".newChangeStocktext",
      textFormat: (v) => `SOLD : ${v}%`,
      storagePrefix: "newChangeStockProgress_",
    },
  ];

  // 公共逻辑封装
  const setupStockBars = (config) => {
    const boxes = document.querySelectorAll(config.containerSelector);

    boxes.forEach((box, index) => {
      const bar = box.querySelector(config.barSelector);
      const text = box.querySelector(config.textSelector);
      const storageKey = config.storagePrefix + index;

      // 初始值
      const startValue = parseFloat(bar.style.width) || 0;
      let currentValue = parseFloat(localStorage.getItem(storageKey)) || startValue;

      // 初始化显示
      bar.style.width = currentValue + "%";
      text.textContent = config.textFormat(currentValue);

      // 每 3600000 即每小时 增长一次
      setInterval(() => {
        currentValue += 2;
        if (currentValue >= 98) currentValue = startValue;

        bar.style.width = currentValue + "%";
        text.textContent = config.textFormat(currentValue);

        localStorage.setItem(storageKey, currentValue);
      }, 3600000);
    });
  };

  // 执行两个组件逻辑
  stockConfigs.forEach(setupStockBars);
});

// ------------------库存条动态变化---------------------





// ----------------轮播图片+按钮模块 电脑端点击按钮左右滑动功能---------------
document.addEventListener("DOMContentLoaded", function () {
  const container = document.querySelector(".newimgswbox");
  if (!container) return;

  const bot = container.querySelector(".newimgswbot");
  const links = Array.from(bot.querySelectorAll(".newimgswlink"));
  const prevBtn = container.querySelector(".newimgswlast");
  const nextBtn = container.querySelector(".newimgswnext");
  const loadMoreBtn = container.querySelector(".newimgswMorbtn");
  function pcSlider() {
    if (!prevBtn || !nextBtn || !bot) return;

    const gap = 20; // 每次滑动间距，可根据实际调整
    const maxScroll = bot.scrollWidth - bot.clientWidth;

    function updateArrow() {
      prevBtn.style.fill = bot.scrollLeft <= 0 ? "#bbbbbb" : "#000";
      nextBtn.style.fill = bot.scrollLeft >= maxScroll ? "#bbbbbb" : "#000";
    }

    // 初始状态
    updateArrow();

    prevBtn.addEventListener("click", () => {
      bot.scrollBy({ left: -bot.clientWidth, behavior: "smooth" });
      setTimeout(updateArrow, 300);
    });

    nextBtn.addEventListener("click", () => {
      bot.scrollBy({ left: bot.clientWidth, behavior: "smooth" });
      setTimeout(updateArrow, 300);
    });

    // 滚动时也更新箭头状态
    bot.addEventListener("scroll", updateArrow);
  }

  // ----------------轮播图片+按钮模块 手机端加载更多功能----------------
  function mobileLoadMore() {
    if (!loadMoreBtn || !links.length) return;

    let visibleCount = 4; // 默认显示前4张
    links.forEach((link, index) => {
      link.style.display = index < visibleCount ? "block" : "none";
    });

    loadMoreBtn.addEventListener("click", () => {
      visibleCount += 2;
      links.forEach((link, index) => {
        if (index < visibleCount) link.style.display = "block";
      });

      if (visibleCount >= links.length) {
        loadMoreBtn.style.display = "none";
      }
    });
  }

  // ============================
  // 根据屏幕尺寸初始化
  // ============================
  function init() {
    const width = window.innerWidth;

    if (width >= 769) {
      // PC端
      if (bot) bot.style.overflowX = "auto";
      pcSlider();
      if (loadMoreBtn) loadMoreBtn.style.display = "none"; // PC隐藏LOAD MORE
    } else {
      // 移动端
      if (bot) bot.style.overflowX = "visible";
      mobileLoadMore();
      if (prevBtn) prevBtn.style.fill = "#bbbbbb";
      if (nextBtn) nextBtn.style.fill = "#bbbbbb";
    }
  }

  init();

  // 屏幕变化时重新初始化
  window.addEventListener("resize", () => {
    // 重置
    links.forEach(link => link.style.display = "");
    if (loadMoreBtn) loadMoreBtn.style.display = "";
    if (bot) bot.scrollLeft = 0;
    init();
  });
});


// ------------------首页Product slider tabs模块 给tab下的图片.section_imgbox动态添加一个类名active------------------
document.addEventListener('DOMContentLoaded', function () {

  const modules = document.querySelectorAll('.section-collection-tabs');

  modules.forEach(module => {

    const boxes = module.querySelectorAll('.section_imgbox');
    const buttons = module.querySelectorAll('.tab-link');
    const contents = module.querySelectorAll('.tab-content');

    if (!boxes.length || !buttons.length || !contents.length) return;

    // ⭐ 找到真正滚动的容器
    const scrollBox =
      module.querySelector('.tabs') ||
      module.querySelector('.tabs--pill');

    let lastScroll = 0;

    // ⭐ 记录当前滚动位置
    if (scrollBox) {
      scrollBox.addEventListener('scroll', () => {
        lastScroll = scrollBox.scrollTop;
      });
    }

    const updateActive = (index) => {

      // tab按钮
      buttons.forEach(b => b.classList.remove('current'));
      if (buttons[index]) buttons[index].classList.add('current');

      // 图片
      boxes.forEach(box => box.classList.remove('active'));
      if (boxes[index]) boxes[index].classList.add('active');

      // tab内容
      contents.forEach(c => c.classList.remove('current'));
      if (contents[index]) contents[index].classList.add('current');
    };

    // 初始化
    buttons.forEach((btn, idx) => {
      if (btn.classList.contains('current')) {
        updateActive(idx);
      }
    });

    // 点击处理（
    function handleClick(index) {

      if (!scrollBox) {
        updateActive(index);
        return;
      }

      const currentScroll = scrollBox.scrollTop;

      updateActive(index);

      // 多重锁定（防止主题JS覆盖）
      requestAnimationFrame(() => {
        scrollBox.scrollTop = currentScroll;

        setTimeout(() => {
          scrollBox.scrollTop = currentScroll;
        }, 50);
      });
    }

    // 点击tab按钮
    buttons.forEach((btn, idx) => {
      btn.addEventListener('click', (e) => {
        e.preventDefault();
        btn.blur(); // 防止focus滚动
        handleClick(idx);
      });
    });

    // 点击图片
    boxes.forEach((box, idx) => {
      box.addEventListener('click', () => {
        handleClick(idx);
      });
    });

  });

});
// ----------------Product slider tabs模块 grid模式加载更多功能--------------------

document.addEventListener('DOMContentLoaded', () => {

  document.querySelectorAll('.section-collection-tabs').forEach((section) => {

    const desktopLimit = parseInt(section.dataset.desktopLimit) || 8
    const mobileLimit = parseInt(section.dataset.mobileLimit) || 8
    const loadCount = 4

    section.querySelectorAll('.tab-content').forEach((tab) => {

      tab.querySelectorAll('.collection-grid').forEach((grid) => {

        const loadMoreBtn = grid.parentElement.querySelector('.gridMoreBtn')
        if (!grid || !loadMoreBtn) return

        // ✅ 判断这个 grid 是 PC 还是 Mobile
        const isMobileGrid = grid.closest('.small-down--show') !== null
        const initialLimit = isMobileGrid ? mobileLimit : desktopLimit

        const productItems = grid.querySelectorAll('.collection-grid__item')
        let visibleCount = initialLimit
        const totalProducts = productItems.length

        function initProducts() {
          productItems.forEach((item, index) => {
            item.style.display = index < initialLimit ? 'block' : 'none'
          })
          loadMoreBtn.style.display = initialLimit >= totalProducts ? 'none' : 'block'
        }

        function loadMore() {
          const nextLimit = Math.min(visibleCount + loadCount, totalProducts)
          for (let i = visibleCount; i < nextLimit; i++) {
            productItems[i].style.display = 'block'
          }
          visibleCount = nextLimit
          if (visibleCount >= totalProducts) {
            loadMoreBtn.style.display = 'none'
          }
        }

        initProducts()
        loadMoreBtn.addEventListener('click', loadMore)

      })

    })

  })

})
// -----------------------Product slider tabs模块tab点击滚动
document.addEventListener('DOMContentLoaded', () => {

  document.querySelectorAll('.section-collection-tabs').forEach((section) => {

    const tabItems = section.querySelectorAll('.tab-link, .section_imgbox')

    tabItems.forEach((item) => {

      item.addEventListener('click', () => {

        setTimeout(() => {

          // 根据端选择正确滚动容器
          const isMobile = window.innerWidth <= 768

          const tabsWrapper = isMobile
            ? section.querySelector('.tabs')        //  mobile
            : section.querySelector('.tabs--pill')  //  pc

          if (!tabsWrapper) return

          let target = item

          if (item.classList.contains('section_imgbox')) {
            target = item.nextElementSibling
          }

          if (!target) return

          if (isMobile) {
            // 横向滚动
            const containerWidth = tabsWrapper.clientWidth
            const itemLeft = target.offsetLeft
            const itemWidth = target.clientWidth

            let scrollLeft = itemLeft - (containerWidth / 2) + (itemWidth / 2)

            const maxScrollLeft = tabsWrapper.scrollWidth - containerWidth
            scrollLeft = Math.max(0, Math.min(scrollLeft, maxScrollLeft))

            tabsWrapper.scrollTo({
              left: scrollLeft,
              behavior: 'smooth'
            })

          } else {
            // 纵向滚动
            const containerHeight = tabsWrapper.clientHeight
            const itemTop = target.offsetTop
            const itemHeight = target.clientHeight

            let scrollTop = itemTop - (containerHeight / 2) + (itemHeight / 2)

            const maxScrollTop = tabsWrapper.scrollHeight - containerHeight
            scrollTop = Math.max(0, Math.min(scrollTop, maxScrollTop))

            tabsWrapper.scrollTo({
              top: scrollTop,
              behavior: 'smooth'
            })
          }

        }, 80) //必须延迟（等 Shopify 切 tab）

      })

    })

  })

})
// -----------------------------------


// ------------------------新tabs模块切换功能
function initTabs(module) {

  // 防重复绑定（关键）
  if (module.dataset.inited) return;
  module.dataset.inited = "true";

  const sectionId = module.dataset.sectionId;
  const tabs = module.querySelectorAll('.hw-tab');

  const imgPanels = module.querySelectorAll('.hw-img-panel');
  const imgMobilePanels = module.querySelectorAll('.hw-mobile-img-panel');
  const productPanels = module.querySelectorAll('.hw-product-panel');
  const btns = module.querySelectorAll('.btntextbox');

  tabs.forEach((tab) => {
    tab.addEventListener('click', function () {

      const blockId = this.dataset.tab;

      // 清除
      tabs.forEach(t => t.classList.remove('active'));
      imgPanels.forEach(p => p.classList.remove('active'));
      imgMobilePanels.forEach(p => p.classList.remove('active'));
      productPanels.forEach(p => p.classList.remove('active'));
      btns.forEach(el => el.classList.remove('active'));

      // 设置
      this.classList.add('active');
      module.querySelector(`#img-${sectionId}-${blockId}`)?.classList.add('active');
      module.querySelector(`#imgm-${sectionId}-${blockId}`)?.classList.add('active');
      module.querySelector(`#product-${sectionId}-${blockId}`)?.classList.add('active');
      this.closest('.btntextbox')?.classList.add('active');
      // 滚动优化
      this.scrollIntoView({
        behavior: 'smooth',
        block: 'nearest',
        inline: 'center'
      });

    });
  });
}
// 首次加载
document.querySelectorAll('.hw-multicollection').forEach(initTabs);

// Shopify 编辑器支持
document.addEventListener('shopify:section:load', function (e) {
  const module = e.target.querySelector('.hw-multicollection');
  if (module) initTabs(module);
});


// 按钮拖拽
document.querySelectorAll('.newthrTabs .hw-tabs').forEach(tabs => {
  let isDown = false;
  let startX;
  let scrollLeft;

  tabs.addEventListener('mousedown', (e) => {
    isDown = true;
    tabs.style.cursor = 'grabbing';
    startX = e.pageX - tabs.offsetLeft;
    scrollLeft = tabs.scrollLeft;
  });

  tabs.addEventListener('mouseleave', () => {
    isDown = false;
    tabs.style.cursor = 'grab';
  });

  tabs.addEventListener('mouseup', () => {
    isDown = false;
    tabs.style.cursor = 'grab';
  });

  tabs.addEventListener('mousemove', (e) => {
    if (!isDown) return;
    e.preventDefault();
    const x = e.pageX - tabs.offsetLeft;
    const walk = (x - startX) * 1.5;
    tabs.scrollLeft = scrollLeft - walk;
  });
});

// ------------------------------



// ------------------nav1（原生nav） 点击高亮功能------------------------------
document.addEventListener('DOMContentLoaded', () => {
  const currentPath = window.location.pathname;
  let bestA = null;
  let bestLen = 0;


  document.querySelectorAll('.menu__item a[href]').forEach(a => {
    const href = a.getAttribute('href');
    if (href && href !== '/' && currentPath.startsWith(href) && href.length > bestLen) {
      bestA = a;
      bestLen = href.length;
    }
  });

  if (bestA) {
    bestA.querySelectorAll('.navtext, .newdropdown-icon').forEach(el => {
      el.style.color = '#ff93a0';
    });
  }
}); 
